function Checkmark() {
  return (
    <div className="checkmark">
      <div className="checkmark_circle"></div>
      <div className="checkmark_stem"></div>
      <div className="checkmark_kick"></div>
    </div>
  );
}

export default Checkmark;
